"use client";

import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link"; // Asegúrate de que esta ruta coincida con tu proyecto

export default function ReadyToWorkWithUs() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  return <section ref={ref}
  // MEJORA 1: Eliminamos text-foreground-dark para evitar que inyecte colores oscuros por defecto
  className="relative bg-dark-background py-20 md:py-32 flex items-center justify-center min-h-[30vh] overflow-hidden">
      {/* Decoración de fondo */}
      <div className="absolute inset-0 bg-gradient-to-br from-primary/10 via-transparent to-secondary/10 pointer-events-none" aria-hidden="true" />

      {/* Patrón de puntos */}
      <div className="absolute inset-0 opacity-5 bg-[radial-gradient(circle_at_50%_50%,_hsl(220,80%,45%)_1px,_transparent_1px)] bg-[size:24px_24px] pointer-events-none" aria-hidden="true" />

      <div className={`relative z-10 max-w-4xl mx-auto px-6 text-center transition-all duration-[350ms] ease-[cubic-bezier(0.4,0,0.2,1)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
        {/* MEJORA 2: Cambiamos "from-foreground" a "from-white" para que el gradiente sea brillante y legible, y agregamos drop-shadow-sm */}
        <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold mb-6 bg-gradient-to-r from-white via-secondary to-accent bg-clip-text text-transparent tracking-tight drop-shadow-sm">
          Ready to Work With Us?
        </h2>

        {/* MEJORA 3: Reemplazamos text-foreground por text-white/90 y agregamos sombra para máxima legibilidad */}
        <p className="text-lg md:text-xl mb-10 text-white/90 drop-shadow-sm max-w-2xl mx-auto leading-[1.7] tracking-wide">
          Experience fast, reliable, and high-quality plumbing services for your commercial or residential needs. Get your free shop estimate today.
        </p>

        {/* NUEVO: Envolvemos el botón en el Link apuntando al ID del input */}
        <Link to="/ContactPage#fullName">
          <Button size="lg"
        // NUEVO: text-black agregado, text-foreground-accent removido
        className="bg-accent text-black hover:bg-accent-hover active:bg-accent-active hover:-translate-y-1 active:translate-y-0 hover:scale-105 active:scale-95 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] shadow-medium hover:shadow-strong focus-visible:ring-2 focus-visible:ring-ring px-10 py-5 text-base md:text-lg font-semibold rounded-lg">
            Get Started
          </Button>
        </Link>
      </div>
    </section>;
}